/**
 * Free shipping progress bar for the cart drawer.
 * Syncs with Impulse CartForm rebuilds via cart:updated and [data-products] DOM updates.
 */
(function () {
  'use strict';

  var DEFAULT_THRESHOLD = 7500;
  var refreshTimer = null;
  var productsObserver = null;

  function formatMoney(cents) {
    var currency =
      window.Shopify && Shopify.currency && Shopify.currency.active
        ? Shopify.currency.active
        : 'USD';

    try {
      var options = {
        style: 'currency',
        currency: currency
      };

      if (cents % 100 === 0) {
        options.minimumFractionDigits = 0;
        options.maximumFractionDigits = 0;
      } else {
        options.minimumFractionDigits = 2;
        options.maximumFractionDigits = 2;
      }

      return new Intl.NumberFormat(
        document.documentElement.lang || 'en-US',
        options
      ).format(cents / 100);
    } catch (error) {
      var amount = cents / 100;
      return cents % 100 === 0
        ? '$' + Math.round(amount)
        : '$' + amount.toFixed(2);
    }
  }

  function getCartFromDrawerDOM() {
    var items = document.querySelector(
      '#CartDrawerForm [data-products] .cart__items'
    );

    if (!items) {
      return null;
    }

    return {
      total_price: parseInt(items.getAttribute('data-cart-subtotal'), 10) || 0,
      item_count: parseInt(items.getAttribute('data-count'), 10) || 0
    };
  }

  function getCart() {
    var root =
      window.Shopify && Shopify.routes && Shopify.routes.root
        ? Shopify.routes.root
        : '/';

    return fetch(root + 'cart.js?t=' + Date.now(), {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('Could not load cart');
      }
      return response.json();
    });
  }

  function updateWidget(cart) {
    if (!cart) {
      return;
    }

    document.querySelectorAll('[data-free-shipping-progress]').forEach(function (widget) {
      var threshold =
        parseInt(widget.getAttribute('data-threshold'), 10) || DEFAULT_THRESHOLD;
      var total = Number(cart.total_price) || 0;
      var itemCount = Number(cart.item_count) || 0;

      widget.hidden = itemCount === 0;

      if (!itemCount) {
        return;
      }

      var remaining = Math.max(threshold - total, 0);
      var percent = Math.min(Math.max((total / threshold) * 100, 0), 100);

      var message = widget.querySelector('[data-free-shipping-message]');
      var bar = widget.querySelector('[data-free-shipping-bar]');
      var track = widget.querySelector('[data-free-shipping-track]');

      if (message) {
        if (total >= threshold) {
          message.innerHTML = "You've unlocked <strong>FREE SHIPPING!</strong>";
        } else {
          message.innerHTML =
            "You're <strong>" +
            formatMoney(remaining) +
            '</strong> away from <strong>FREE SHIPPING</strong>';
        }
      }

      if (bar) {
        bar.style.width = percent + '%';
      }

      if (track) {
        track.setAttribute('aria-valuenow', String(Math.round(percent)));
      }
    });
  }

  function refreshFromDrawerDOM() {
    var cart = getCartFromDrawerDOM();
    if (cart) {
      updateWidget(cart);
    }
  }

  function refreshFromAPI() {
    getCart()
      .then(updateWidget)
      .catch(function (error) {
        console.warn('Free shipping progress:', error);
      });
  }

  function scheduleAPIRefresh(delay) {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(refreshFromAPI, typeof delay === 'number' ? delay : 100);
  }

  function startProductsObserver() {
    var productsHost = document.querySelector('#CartDrawerForm [data-products]');
    if (!productsHost) {
      return;
    }

    if (productsObserver) {
      productsObserver.disconnect();
    }

    productsObserver = new MutationObserver(function () {
      refreshFromDrawerDOM();
    });

    productsObserver.observe(productsHost, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['data-cart-subtotal', 'data-count']
    });
  }

  function init() {
    document.addEventListener('cart:updated', function (event) {
      if (event.detail && event.detail.cart) {
        updateWidget(event.detail.cart);
      } else {
        scheduleAPIRefresh(50);
      }
    });

    document.addEventListener('cart:quantity.cart-cart-drawer', function () {
      scheduleAPIRefresh(150);
    });

    document.addEventListener('ajaxProduct:added', function () {
      scheduleAPIRefresh(100);
    });

    document.addEventListener('drawerOpen.CartDrawer', function () {
      startProductsObserver();
      refreshFromDrawerDOM();
      scheduleAPIRefresh(50);
    });

    startProductsObserver();
    refreshFromDrawerDOM();
    scheduleAPIRefresh(0);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
